import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const routeConfig = [MainRoutes, AuthenticationRoutes];

export default function ThemeRoutes() {
  return useRoutes(routeConfig);
}
